import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title align-items-center d-flex flex-wrap" }
const _hoisted_4 = { class: "card-label" }
const _hoisted_5 = { class: "ms-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "me-4" }, "filter", -1)
const _hoisted_7 = {
  class: "btn-group custom-type-filter",
  role: "group",
  "aria-label": "Filter"
}
const _hoisted_8 = { class: "card-toolbar" }
const _hoisted_9 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Create Promotion ")
const _hoisted_12 = { class: "card-body pt-0" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "d-flex justify-content-start align-items-center" }
const _hoisted_15 = { class: "symbol symbol-50px" }
const _hoisted_16 = { style: {"padding-left":"1em"} }
const _hoisted_17 = { class: "d-flex flex-center flex-wrap" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary custom-slim-btn" }, "View/Edit", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString($setup.breadcrumbs[1][$setup.breadcrumbs[1].length - 1]), 1),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("input", {
              type: "radio",
              class: "btn-check",
              id: "fixRadio",
              autocomplete: "off",
              name: "type",
              checked: "",
              value: "Fix",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleRadioChange && $setup.handleRadioChange(...args)))
            }, null, 32),
            _createElementVNode("label", {
              class: _normalizeClass(["btn btn-outline-primary", { active: _ctx.type == $setup.PromotionTypeEnum.FIX }]),
              for: "fixRadio"
            }, "Fix", 2),
            _createElementVNode("input", {
              type: "radio",
              class: "btn-check",
              id: "prefixRadio",
              name: "type",
              autocomplete: "off",
              value: "Prefix",
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleRadioChange && $setup.handleRadioChange(...args)))
            }, null, 32),
            _createElementVNode("label", {
              class: _normalizeClass(["btn btn-outline-primary", { active: _ctx.type == $setup.PromotionTypeEnum.PREFIX }]),
              for: "prefixRadio"
            }, "Prefix", 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_link, {
            to: "/promotions/new",
            class: "btn btn-flex btn-success"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
              ]),
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_Datatable, {
        ref: "tableRef",
        "table-header": $setup.tableHeader,
        "table-data": _ctx.tableData,
        loading: _ctx.loading,
        total: _ctx.total
      }, _createSlots({
        "cell-no": _withCtx(({ index }) => [
          _createTextVNode(_toDisplayString(index + 1 + _ctx.rowsPerPage * (_ctx.currentPage - 1)), 1)
        ]),
        "cell-prefixCode": _withCtx(({ row }) => [
          (row.type == $setup.PromotionTypeEnum.FIX)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(row.prefixCode), 1))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: `/promotions/${row.id}/coupon`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(`${row.prefixCode}(${row.quantity || 1})`), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
        ]),
        "cell-startDate": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString($setup.dateFormat(row.startDate, 'DD/MM/YYYY')), 1)
        ]),
        "cell-endDate": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString($setup.dateFormat(row.endDate, 'DD/MM/YYYY')), 1)
        ]),
        "cell-isActive": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.isActive ? 'เปิดใช้งาน' : 'ไม่เปิดใช้งาน'), 1)
        ]),
        "cell-owner": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.owner?.name || '-'), 1)
        ]),
        "cell-storeDetail": _withCtx(({ row }) => [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", {
                class: "custom-image-box",
                style: _normalizeStyle(`background-image: url('${
                  row.image || 'media/images/steam-question-mark-icon-29.jpg'
                }')`)
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", null, _toDisplayString(row.name), 1)
            ])
          ])
        ]),
        "cell-editView": _withCtx(({ row }) => [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_router_link, {
              to: `/promotions/${row.id}`
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 2
            }, 1032, ["to"])
          ])
        ]),
        _: 2
      }, [
        _renderList($setup.tableHeader.filter(
            (data) =>
              ![
                'prefixCode',
                'startDate',
                'endDate',
                'isActive',
                'editView',
              ].includes(data.key)
          ), (item, i) => {
          return {
            name: `cell-${item.key}`,
            fn: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(row[`${item.key}`]), 1)
            ])
          }
        })
      ]), 1032, ["table-header", "table-data", "loading", "total"])
    ])
  ]))
}